import type * as React from 'react';

/** Design tokens for the approved Mumzworld UI — bright/light, subtle
 * borders, generous whitespace, minimal shadows, pastel icon backgrounds.
 * Plain style-object tokens (no new CSS framework dependency) since the
 * existing app only carries MUI v4 + @backstage/ui. */
export const colors = {
  bg: '#f7f8fa',
  surface: '#ffffff',
  border: '#e6e8eb',
  borderLight: '#eef0f2',
  text: '#1a1d21',
  textMuted: '#6b7280',
  primary: '#5b5fef',
  primaryLight: '#eef0ff',
  success: '#16a34a',
  danger: '#dc2626',
  pillBg: '#eef2ff',
  pillText: '#4338ca',
};

export const cardStyle: React.CSSProperties = {
  background: colors.surface,
  border: `1px solid ${colors.border}`,
  borderRadius: 12,
  boxShadow: '0 1px 2px rgba(16, 24, 40, 0.04)',
};

export const kindIconBg: Record<string, string> = {
  frontend: '#dbeafe',
  backend: '#dcfce7',
  'ai-agent': '#fde2d5',
  worker: '#fef3c7',
  'scheduled-job': '#ede9fe',
  fullstack: '#e0e7ff',
  compose: '#cffafe',
};

export const kindIconColor: Record<string, string> = {
  frontend: '#2563eb',
  backend: '#16a34a',
  'ai-agent': '#ea580c',
  worker: '#ca8a04',
  'scheduled-job': '#7c3aed',
  fullstack: '#4338ca',
  compose: '#0e7490',
};
